import React from 'react'

const HeaderWrapper = ({ children }) => (
  <div className="navbar-wrapper">
    {children}
    <style jsx>
      {`
        .navbar-wrapper {
          width: 100%;
          height: 64px;
          position: fixed;
          top: 0;
          z-index: 99;
          background-color: #fff;

          border-top: solid 4px #2440a4;
          border-image: linear-gradient(to right, #00beff, #0fc3c4) 1 0 0 !important;
          box-shadow: 0 2px 12px 0 rgba(26, 52, 79, 0.1) !important;
          @media screen and (min-width: 768px) {
            height: 78px;
          }
        }
      `}
    </style>
  </div>
)

export default HeaderWrapper
